export default __webpack_public_path__ + "static/5-633a3ec29cf916014205750a02c574cf.jpeg";